<template>
    <VDialog v-model="visivel" max-width="300px">
        <VLayout row>
            <VFlex>
                <VCard>
                    <VCardTitle class="subheading">Alterar situação de todos os eventos não executados para:</VCardTitle>
                    <VCardText>
                        <VList>
                            <VListTile v-for="s in situacoes" :key="s" class="clicavel">
                                <VListTileTitle @click="escolherSituacao(s)">{{ s }}</VListTileTitle>
                            </VListTile>
                        </VList>
                    </VCardText>
                    <VCardActions>
                        <VLayout justify-end>
                            <VBtn flat @click="visivel = false">Cancelar</VBtn>
                        </VLayout>
                    </VCardActions>
                </VCard>
            </VFlex>
        </VLayout>
    </VDialog>
</template>

<script>
    export default {
        name: "SituacaoComanda",
        data() {
            return {
                visivel: false
            }
        },
        props: {
            value: {
                type: Boolean,
                default: false
            },
            situacoes: {
                type: Array,
                default: () => []
            }
        },
        watch: {
            value(v) {
                this.visivel = v;
            },
            visivel(v, oldV) {
                if (v !== oldV) {
                    this.$emit('input', v);
                }
            }
        },
        methods: {
            escolherSituacao(situacao) {
                this.$emit('update:situacao', situacao);
                this.visivel = false;
            }
        }
    }
</script>

<style scoped>

</style>
